import { NextPageWithLayout } from '#/pages/_app'
import { SubscriptionRecurrentPage } from './subscription-recurrent'


const SubscriptionPage: NextPageWithLayout = () => {
		return <SubscriptionRecurrentPage />
}

export default SubscriptionPage
